import { ComposerPrimitive } from '@assistant-ui/react';

import { ComposerIntentConfirmation, ComposerMentions, ComposerReply } from 'components/composer/composer-context';
import { ComposerFlow } from 'components/composer/composer-flow';

const Composer = ({
	type = 'app',
	disabled = false,
	loading = false,
	canManagePreferences = false,
	canManageProjectDefaults = false,
	rootApi = undefined,
	model,
	modelDisabled = false,
	onModelSelect,
	onPreferencesChange = undefined,
	preferences = undefined,
	connectors = [],
	onDraftPreferencesChange = undefined,
	onDraftConnectorsChange = undefined,
	onPlanModeChange = undefined,
	deliveryMode = 'queue',
	onDeliveryModeChange = undefined,
	modeDisabled = false,
	placeholder,
	planMode = false,
	showFocusRing = true,
	replyTo = null,
	targets = {},
	selectedTargets = [],
	intentConfirmation = null,
	onIntentChoose = undefined,
	onIntentDismiss = undefined,
	onReplyClear = undefined,
	onTargetSelect = undefined,
	onTargetRemove = undefined,
}) => {
	return (
		<ComposerPrimitive.Root data-model-id={model?.uuid || model?.id} className='relative'>
			<ComposerReply message={replyTo} onClear={onReplyClear} />
			<ComposerFlow
				type={type}
				disabled={disabled || loading}
				canManagePreferences={canManagePreferences}
				canManageProjectDefaults={canManageProjectDefaults}
				rootApi={rootApi}
				model={model}
				modelDisabled={modelDisabled}
				onModelSelect={onModelSelect}
				onPreferencesChange={onPreferencesChange}
				preferences={preferences}
				connectors={connectors}
				onDraftPreferencesChange={onDraftPreferencesChange}
				onDraftConnectorsChange={onDraftConnectorsChange}
				deliveryMode={deliveryMode}
				onDeliveryModeChange={onDeliveryModeChange}
				modeDisabled={modeDisabled}
				placeholder={placeholder}
				planMode={planMode}
				showFocusRing={showFocusRing}
				onPlanModeChange={onPlanModeChange}
			/>
			<ComposerMentions
				targets={targets}
				selected={selectedTargets}
				onSelect={onTargetSelect}
				onRemove={onTargetRemove}
			/>
			<ComposerIntentConfirmation
				confirmation={intentConfirmation}
				onChoose={onIntentChoose}
				onDismiss={onIntentDismiss}
			/>
		</ComposerPrimitive.Root>
	);
};

export { Composer };
